import { render, staticRenderFns } from "./Location.vue?vue&type=template&id=20886ba4&"
import script from "./Location.vue?vue&type=script&lang=js&"
export * from "./Location.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/admin/Docker/apps2/privacy/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20886ba4')) {
      api.createRecord('20886ba4', component.options)
    } else {
      api.reload('20886ba4', component.options)
    }
    module.hot.accept("./Location.vue?vue&type=template&id=20886ba4&", function () {
      api.rerender('20886ba4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Location.vue"
export default component.exports